import { companyTypes } from '@/data/type-maps';
import { authService } from '@/models/auth';
import { featureFlagService } from '@/models/feature-flag';
import { useAuthStore } from '@/stores/auth';
function isIndividualActivity() {
    var _a;
    const companyType = (_a = useAuthStore().company) === null || _a === void 0 ? void 0 : _a.company_type_id;
    return companyType === companyTypes.individual_activity || companyType === companyTypes.individual_activity_with_license;
}
/**
 * Whether existing compensations can be listed; a plan below Business still opens them, as CompensationPolicy decides.
 */
export function compensationListAccess() {
    return featureFlagService.can('compensation-invoice') && authService.can('invoice.index') && !isIndividualActivity();
}
/**
 * Whether new compensations can be started: individual activity never has them, and a plan
 * below Business shows them locked, as CompensationPolicy decides on the server.
 */
export function compensationCreateAccess() {
    if (!featureFlagService.can('compensation-invoice') || !authService.can('invoice.create') || isIndividualActivity()) {
        return 'hidden';
    }
    return authService.canSub('compensations') ? 'enabled' : 'disabled';
}
export function compensationExportAccess() {
    if (!compensationListAccess() || !authService.can('invoice.export')) {
        return 'hidden';
    }
    return authService.canSub('exports') ? 'enabled' : 'disabled';
}
